<h1>Items</h1>

<p>This page is a demo of a very basic todo list in Angular, using the Firebase Realtime DB on the backend.</p>

<div *ngFor="let item of items | async" class="card">
  <item-detail [item]='item'></item-detail>
</div>

<loading-spinner *ngIf="showSpinner"></loading-spinner>

<button type="button" class="button is-danger" (click)='deleteItems()'>Delete Entire List</button>

<hr>

<item-form></item-form>



// WEBPACK FOOTER //
// ./src/app/items/items-list/items-list.component.html